import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from "@angular/fire/auth";
import {AngularFireStorageModule, BUCKET} from "@angular/fire/storage";

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TradeListComponent } from './trade-list/trade-list.component';
import {  FormsModule } from "@angular/forms";
import {  TextareaAutosizeModule  } from "ngx-textarea-autosize";
import { FlashMessagesModule } from 'angular2-flash-messages';
import {  AuthService } from "./services/auth.service";
import { LoginComponent } from './login/login.component';
import { IdeaListComponent } from './idea-list/idea-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {DataTableModule} from "@pascalhonegger/ng-datatable";

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    NavbarComponent,
    PageNotFoundComponent,
    TradeListComponent,
    LoginComponent,
    IdeaListComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    FormsModule,
    DataTableModule,
    TextareaAutosizeModule,
    FlashMessagesModule.forRoot(),
    NgbModule,
  ],
  providers: [AuthService, {provide: BUCKET, useValue: 'deltatrading-27ac4.appspot.com'}],
  bootstrap: [AppComponent]
})
export class AppModule { }
